import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext.js";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function PatientCabinet() {
  const { user, logout } = useAuth();
  const [profile, setProfile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [certificate, setCertificate] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({
    fullName: "",
    birthDate: "",
    phone: "",
    email: "",
    password: "",
  });

  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.urniidvi.ru"
      : "http://localhost:5000";

  // Загрузка профиля, файлов и справки
  useEffect(() => {
    if (!user?.token) return logout();

    // Профиль
    fetch(`${API_URL}/api/patient/profile`, {
      headers: { Authorization: "Bearer " + user.token },
    })
      .then((res) => res.json())
      .then((data) => {
        setProfile(data);
        setForm({
          fullName: data.fullName || "",
          birthDate: data.birthDate || "",
          phone: data.phone || "",
          email: data.email || "",
          password: "",
        });
      });

    // Файлы
    fetch(`${API_URL}/api/patient/files`, {
      headers: { Authorization: "Bearer " + user.token },
    })
      .then((res) => res.json())
      .then((data) => setUploadedFiles(data));

    // Справка
    fetch(`${API_URL}/api/patient/certificate`, {
      headers: { Authorization: "Bearer " + user.token },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.message) setCertificate(data);
      });
  }, [user, logout, API_URL]);

  // Загрузка заявления
  const handleFileUpload = async (e) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    const res = await fetch(`${API_URL}/api/patient/upload`, {
      method: "POST",
      headers: { Authorization: "Bearer " + user.token },
      body: formData,
    });
    const data = await res.json();
    if (res.ok) setUploadedFiles((prev) => [...prev, data.file]);
  };

  // Скачивание файла
  const handleDownloadFile = async (file) => {
    if (!file?.safeName) {
      console.error("file.safeName отсутствует", file);
      return;
    }

    try {
      const res = await fetch(
        `${API_URL}/api/patient/download/${file.safeName}`,
        {
          headers: { Authorization: "Bearer " + user.token },
        }
      );
      if (!res.ok) throw new Error("Ошибка загрузки");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = file.name || "document";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Ошибка скачивания:", err);
    }
  };

  // Скачивание шаблона заявления
  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/files/patients/zayv_nalog_med.pdf";
    link.download = "zayv_nalog_med.pdf";
    link.click();
  };

  // Скачивание справки
  // const handleDownloadCertificate = () => {
  //   if (certificate?.safeName) handleDownloadFile(certificate);
  // };

  // Сохранение профиля
  const handleSave = async () => {
    try {
      const res = await fetch(`${API_URL}/api/patient/profile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) {
        setProfile(data);
        setEditing(false);
        setForm((prev) => ({ ...prev, password: "" }));
      } else console.error("Ошибка сохранения:", data.message);
    } catch (err) {
      console.error("Ошибка сохранения:", err);
    }
  };

  if (!user?.token) return <p>Авторизуйтесь</p>;
  if (!profile) return <p>Загрузка...</p>;

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Личный кабинет
      </h1>

      {/* Профиль */}
      <div className="cabinet__info">
        {editing ? (
          <>
            <input
              className="patient__holder"
              type="text"
              value={form.fullName}
              onChange={(e) => setForm({ ...form, fullName: e.target.value })}
              placeholder="ФИО"
            />
            <input
              className="patient__holder"
              type="date"
              value={form.birthDate}
              onChange={(e) => setForm({ ...form, birthDate: e.target.value })}
            />
            <input
              className="patient__holder"
              type="tel"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
            />
            <input
              className="patient__holder"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
            <input
              className="patient__holder"
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Новый пароль (необязательно)"
            />
            <button onClick={handleSave} className="btn">
              Сохранить
            </button>
          </>
        ) : (
          <>
            <p>ФИО: {profile.fullName}</p>
            <p>Дата рождения: {profile.birthDate}</p>
            <p>Телефон: {profile.phone}</p>
            <p>Email: {profile.email}</p>
            <button onClick={() => setEditing(true)} className="btn">
              Редактировать
            </button>
          </>
        )}
      </div>

      {/* Заявления */}
      <div className="cabinet__block">
        <p>Заявление</p>
        <button onClick={handleDownloadTemplate} className="btn">
          Скачать шаблон
        </button>

        <div className="upload">
          <p className="cabinet__text">Прикрепить заполненное заявление</p>
          <input
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.bmp"
            onChange={handleFileUpload}
            hidden
            id="uploadInput"
          />
          <label htmlFor="uploadInput" className="cabinet__label">
            <p className="btn">Загрузить заявление</p>
          </label>
        </div>

        {uploadedFiles.map((f, i) => (
          <li key={i}>
            <p className="cabinet__text">
              Прикрепленно заявление: <br></br> {f.name}
            </p>
            <button onClick={() => handleDownloadFile(f)} className="btn">
              Скачать
            </button>
          </li>
        ))}
      </div>

      {/* Справка */}
      <div className="cabinet__block">
        <p>Справка</p>
        {/* <p className="login__label">Скачать справку:</p> */}
        {!certificate?.safeName && <p>Справка пока не загружена</p>}
        {certificate?.safeName && (
          <button
            className="btn"
            onClick={() => handleDownloadFile(certificate)}
          >
            Сохранить {certificate.name}
          </button>
        )}
      </div>

      <button onClick={logout} className="btn btn--secondary">
        Выйти
      </button>
    </section>
  );
}
